const SERVICE_ICON_DIR = '/img/package-services';

const SERVICE_BY_CODIGO = {
  // Solid
  'fa fa-bed': { key: 'Hotels', src: `${SERVICE_ICON_DIR}/alojamiento.png`, variant: 'solid' },
  'fa fa-medkit': { key: 'Insurance', src: `${SERVICE_ICON_DIR}/asistencia.png`, variant: 'solid' },
  'fa fa-ticket-alt': { key: 'Activities', src: `${SERVICE_ICON_DIR}/excursiones.png`, variant: 'solid' },
  'fa fa-ticket': { key: 'Activities', src: `${SERVICE_ICON_DIR}/excursiones.png`, variant: 'solid' },
  'fa fa-plane': { key: 'Flights', src: `${SERVICE_ICON_DIR}/vuelos.png`, variant: 'solid' },
  'fa fa-utensils': { key: 'Full Board', src: `${SERVICE_ICON_DIR}/comidas.png`, variant: 'solid' },
  'fa fa-coffee': { key: 'Breakfast', src: `${SERVICE_ICON_DIR}/desayuno.png`, variant: 'solid' },
  'fa fa-ship': { key: 'Cruise', src: `${SERVICE_ICON_DIR}/crucero.png`, variant: 'solid' },
  'fa fa-suitcase': { key: 'Packages', src: `${SERVICE_ICON_DIR}/equipaje.png`, variant: 'solid' },
  'fa fa-cocktail': { key: 'Drinks', src: `${SERVICE_ICON_DIR}/bebidas.png`, variant: 'solid' },
  'fa fa-car': { key: 'Transfers', src: `${SERVICE_ICON_DIR}/traslados.png`, variant: 'solid' },
  'fa fa-users': { key: 'Group Departure', src: `${SERVICE_ICON_DIR}/salida-grupal.png`, variant: 'solid' },
  'fa fa-comment': { key: 'Tour Guide', src: `${SERVICE_ICON_DIR}/guia-turistico.png`, variant: 'solid' },

  // Line
  'fa fa-bed-line': { key: 'Hotels', src: `${SERVICE_ICON_DIR}/alojamiento-line.png`, variant: 'line' },
  'fa fa-medkit-line': { key: 'Insurance', src: `${SERVICE_ICON_DIR}/asistencia-line.png`, variant: 'line' },
  'fa fa-ticket-alt-line': { key: 'Activities', src: `${SERVICE_ICON_DIR}/excursiones-line.png`, variant: 'line' },
  'fa fa-ticket-line': { key: 'Activities', src: `${SERVICE_ICON_DIR}/excursiones-line.png`, variant: 'line' },
  'fa fa-plane-line': { key: 'Flights', src: `${SERVICE_ICON_DIR}/vuelos-line.png`, variant: 'line' },
  'fa fa-utensils-line': { key: 'Full Board', src: `${SERVICE_ICON_DIR}/comidas-line.png`, variant: 'line' },
  'fa fa-coffee-line': { key: 'Breakfast', src: `${SERVICE_ICON_DIR}/desayuno-line.png`, variant: 'line' },
  'fa fa-ship-line': { key: 'Cruise', src: `${SERVICE_ICON_DIR}/crucero-line.png`, variant: 'line' },
  'fa fa-suitcase-line': { key: 'Packages', src: `${SERVICE_ICON_DIR}/equipaje-line.png`, variant: 'line' },
  'fa fa-cocktail-line': { key: 'Drinks', src: `${SERVICE_ICON_DIR}/bebidas-line.png`, variant: 'line' },
  'fa fa-car-line': { key: 'Transfers', src: `${SERVICE_ICON_DIR}/traslados-line.png`, variant: 'line' },
  'fa fa-users-line': { key: 'Group Departure', src: `${SERVICE_ICON_DIR}/salida-grupal-line.png`, variant: 'line' },
  'fa fa-comment-line': { key: 'Tour Guide', src: `${SERVICE_ICON_DIR}/guia-turistico-line.png`, variant: 'line' },
};

const DESCRIPTION_ALIASES = {
  hotels: 'Hotels',
  alojamiento: 'Hotels',
  insurance: 'Insurance',
  asistencia: 'Insurance',
  activities: 'Activities',
  actividades: 'Activities',
  excursiones: 'Activities',
  flights: 'Flights',
  vuelos: 'Flights',
  aereos: 'Flights',
  aéreos: 'Flights',
  'full board': 'Full Board',
  comidas: 'Full Board',
  'pensión completa': 'Full Board',
  'pension completa': 'Full Board',
  breakfast: 'Breakfast',
  desayuno: 'Breakfast',
  passport: 'Passport',
  pasaporte: 'Passport',
  cruise: 'Cruise',
  crucero: 'Cruise',
  visa: 'Visa',
  'tour guide': 'Tour Guide',
  'guía turístico': 'Tour Guide',
  'guia turistico': 'Tour Guide',
  guía: 'Tour Guide',
  guia: 'Tour Guide',
  acompañada: 'Tour Guide',
  acompanada: 'Tour Guide',
  accompanied: 'Tour Guide',
  acompanhada: 'Tour Guide',
  'grupal acompañada': 'Tour Guide',
  'grupal acompanada': 'Tour Guide',
  'grupal acompanhada': 'Tour Guide',
  'salida grupal acompañada': 'Tour Guide',
  packages: 'Packages',
  equipaje: 'Packages',
  tickets: 'Activities',
  boleto: 'Activities',
  entradas: 'Activities',
  drinks: 'Drinks',
  bebidas: 'Drinks',
  transfers: 'Transfers',
  transfer: 'Transfers',
  traslados: 'Transfers',
  traslado: 'Transfers',
  'group departure': 'Group Departure',
  'salida grupal': 'Group Departure',
  'saída em grupo': 'Group Departure',
  'saida em grupo': 'Group Departure',
};

const SERVICE_BY_KEY = {
  solid: {},
  line: {},
};
Object.values(SERVICE_BY_CODIGO).forEach(item => {
  const variant = item.variant || 'solid';
  if (!SERVICE_BY_KEY[variant][item.key]) {
    SERVICE_BY_KEY[variant][item.key] = item;
  }
});

function normalizeDescription(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

export function getPackageServiceVariant(icon) {
  const code = String(icon?.codigo || '').trim().toLowerCase();
  return code.endsWith('-line') ? 'line' : 'solid';
}

export function resolvePackageService(icon) {
  if (!icon) return null;
  const byCodigo = icon.codigo ? SERVICE_BY_CODIGO[String(icon.codigo).trim()] : null;
  if (byCodigo) return byCodigo;
  const aliasKey = DESCRIPTION_ALIASES[
    normalizeDescription(icon.descripcion || icon.nombre || icon.name)
  ];
  if (!aliasKey) return null;
  const variant = getPackageServiceVariant(icon);
  return SERVICE_BY_KEY[variant]?.[aliasKey] || SERVICE_BY_KEY.solid[aliasKey] || null;
}

export function getPackageServiceFallbackLabel(icon) {
  return icon?.descripcion || icon?.nombre || icon?.name || icon?.codigo || '';
}

export function getPackageServiceLabel(icon, t) {
  const fallback = getPackageServiceFallbackLabel(icon);
  const resolved = resolvePackageService(icon);
  if (!resolved || !t) return fallback;
  return t(`packages.preview.serviceItems.${resolved.key}`, { defaultValue: fallback });
}

export function resolvePackageServiceGlyph(icon) {
  const resolved = resolvePackageService(icon);
  if (resolved?.src) return { type: 'svg', src: resolved.src };
  return { type: 'fa', className: icon?.codigo || '' };
}
